/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-imagemap-portlet')) {
  import(/* webpackChunkName: "imagemap-portlet" */ './imageMap-slim');
}
